import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  FormGroup,
  FormControl,
  ShopifyResourcePicker,
  Button,
  ButtonSelect,
  Input,
  ProductSelector,
  ImagePicker,
  Modal,
  Carousel,
  RichEditor,
  Alert,
  ColorPicker,
  Dropdown
} from "components";
import {
  ONE_CHECK_UP_SELL_PRODUCT_TYPE_OPTIONS,
  ONE_CHECK_UP_SELL_PRODUCT_REDUCER,
  CAMPAIGN_TYPES,
  BREAK_POINTS
} from "lib/globals";
import { API } from "aws-amplify";
import styles from "styles/campaign_settings_second_step.module.scss";
import { CartContext } from "components/cart";
import ShopContext from "context/ShopContext";
import classNames from "lib/classNames";
import useRefState from "hooks/useRefState";
import EmbeddedContext from "context/EmbeddedContext";

const MultiOneCheckUpSell = ({ context, validationErrors }) => {
  const { state: campaign, setItem } = context;
  const { AppBridgeToast } = useContext(EmbeddedContext);
  const shopContext = useContext(ShopContext);
  const {
    state: {
      settings: { theme, rtl },
      currency
    }
  } = shopContext;
  const [hiddenProducts, setHiddenProducts] = useState([]);
  const newHiddenProductDefault = { title: "", image: "", price: "" };
  // const [newHiddenProduct, setNewHiddenProduct, newHiddenProductRef] = useRefState(newHiddenProductDefault);
  const [newHiddenProductLoading, setNewHiddenProductLoading] = useState(false);
  const [productsFetchLoading, setProductsFetchLoading] = useState(true);
  const [showHiddenProductSelector, setShowHiddenProductSelector] =
    useState(false);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setProductsFetchLoading(true);
    API.get("API_GATEWAY_NEW", "/products", {
      queryStringParameters: {
        type: "hidden",
        limit: 4
      }
    })
      .then(({ products }) => {
        setHiddenProducts(products);
        setProductsFetchLoading(false);
      })
      .catch(console.log);
  }, []);

  const products = campaign.settings.multi_one_check_upsell.products;
  const isSwitch = campaign.settings.multi_one_check_upsell.variant === "switch"
  return (
    <FormGroup
      label={CAMPAIGN_TYPES["one_check_up_sell"]}
      info="Create a tick box that adds a little extra product to the cart."
    >
      <FormControl label="Variant">
        <Dropdown
          options={[
            { value: "switch", label: "Switch" },
            { value: "square", label: "Square" },
            { value: "circle", label: "Circle" }
          ]}
          first
          BindToContext={[context, "settings.multi_one_check_upsell.variant"]}
        />
      </FormControl>
      <FormControl
        label="Align"
        info="Align center works good with a single product"
      >
        <Dropdown
          options={[
            { value: "natural", label: rtl ? "Right" : "Left" },
            { value: "center", label: "Center" }
          ]}
          first
          BindToContext={[context, "settings.multi_one_check_upsell.align"]}
        />
      </FormControl>
      <FormControl
        label="Border"
        isSingleCol
        withSwitch={[context, "settings.multi_one_check_upsell.border"]}
      />
      <FormControl label="Colors">
        <ColorPicker
          text="Highlight"
          BindToContext={[
            context,
            "settings.multi_one_check_upsell.highlight"
          ]}
        />
        <ColorPicker
          text="Border"
          BindToContext={[
            context,
            "settings.multi_one_check_upsell.border_color"
          ]}
        />
        {isSwitch && (
          <ColorPicker
            text="Switch ON"
            disableAlpha
            BindToContext={[
              context,
              "settings.multi_one_check_upsell.switch_on"
            ]}
          />
        )}
        {isSwitch && (
          <ColorPicker
            text="Switch OFF"
            disableAlpha
            BindToContext={[
              context,
              "settings.multi_one_check_upsell.switch_off"
            ]}
          />
        )}
      </FormControl>
      {products.map((product, index) => (
        <div
          key={`product_${index}`}
          className={classNames("mb-5 p-4 rounded bg-white relative")}
        >
          {products.length > 1 && index !== 0 && (
            <Button
              className={classNames(
                "absolute top-0 right-0 -translate-y-1/2 transform translate-x-1/2"
              )}
              icon="times"
              type="circle-danger"
              onClick={() => context.deleteOneCheckUpsellProduct(index)}
            />
          )}
          <FormControl
            label="Ticked by default"
            info="When campaign is active it will auto tick the box and add one tick upsell product to the cart."
            withSwitch={[
              context,
              `settings.multi_one_check_upsell.products.${index}.is_ticked_by_default`
            ]}
          >
            <div></div>
          </FormControl>
          <FormControl
            label="Include in add to unlock goal"
            info="The one tick product amount will count towards Add To Unlock reward goals."
            withSwitch={[
              context,
              `settings.multi_one_check_upsell.products.${index}.include_in_atu`
            ]}
          >
            <div></div>
          </FormControl>
          <FormControl label="Text">
            <RichEditor
              placeholder="Enter your sold here!"
              BindToContext={[
                context,
                `settings.multi_one_check_upsell.products.${index}.text`
              ]}
              indicator="You can use {{title}} {{price}}"
              error={productError(validationErrors, index)}
            />
          </FormControl>
          <FormControl label="Limit product name length">
            <Input
              // onFocus={() => setEditingProductDetails(true)}
              // onBlur={() => setEditingProductDetails(false)}
              type="number"
              placeholder="Characters length"
              BindToContext={[
                context,
                `settings.multi_one_check_upsell.products.${index}.truncate_length`
              ]}
              withSwitch={[
                context,
                `settings.multi_one_check_upsell.products.${index}.truncate`
              ]}
            />
          </FormControl>
          <FormControl
            label="Product"
            error={productError(validationErrors, index)}
            info={`Choose the product you want tick box to add to the cart.${!BREAK_POINTS["kill_draft"](shopContext)
              ? " Virtual products are invisible on your storefront, And existing products are not."
              : ""
              }`}
            isSingleCol
          >
            {!BREAK_POINTS["kill_draft"](shopContext) && (
              <ButtonSelect
                options={ONE_CHECK_UP_SELL_PRODUCT_TYPE_OPTIONS}
                BindToContext={[
                  context,
                  `settings.multi_one_check_upsell.products.${index}.product_type`
                ]}
                first
                loading={[productsFetchLoading]}
              />
            )}
            <ShopifyResourcePicker
              allowMultiple={false}
              reducer={ONE_CHECK_UP_SELL_PRODUCT_REDUCER}
              verifySelection={([{ id, title }]) => {
                id = id.replace("gid://shopify/Product/", "");
                const exists = products
                  .filter(({ product }) => !!product)
                  .find(({ product }) => id === product.id);
                if (exists) {
                  AppBridgeToast({
                    message: `"${title}" is already selected`,
                    isError: true
                  }).open();
                }
                return !exists;
              }}
              BindToContext={[
                context,
                `settings.multi_one_check_upsell.products.${index}.product`
              ]}
            >
              {(trigger) => (
                <Button
                  className={classNames("w-full mt-3")}
                  text="Select a product"
                  type={
                    productError(validationErrors, index)
                      ? "danger"
                      : "primary"
                  }
                  onClick={() => {
                    switch (product.product_type) {
                      case "existing":
                        return trigger();
                      case "hidden":
                        return setShowHiddenProductSelector(true);
                    }
                  }}
                />
              )}
            </ShopifyResourcePicker>
          </FormControl>
          <FormControl>
            <Summary campaign={context.state} product={product.product} />
          </FormControl>
        </div>
      ))}
      <FormControl>
        <div>
          <Button
            text={
              products.length < 4
                ? "+ Add another product"
                : "Only 3 products are available"
            }
            onClick={context.newOneCheckUpsellProduct}
            style={{ width: "100%" }}
            disabled={products.length >= 3}
          />
        </div>
      </FormControl>
    </FormGroup>
  );
};

export default MultiOneCheckUpSell;

const Summary = ({ campaign, product }) => {
  const { target } = campaign;
  if (!Object.keys(product || {}).length) return null;
  if (
    (target.type === "specific_products" && !target.selected.length) ||
    !product
  )
    return null;
  const must_truncated = (text) => text.length > 25;
  const truncate_name = (text) =>
    `${text.substring(0, 25).trim()}${must_truncated(text) ? "..." : ""}"`;
  const product_name =
    target.type === "specific_products"
      ? truncate_name(target.selected[0].title)
      : "any product";
  if (!product.title) return null;

  return (
    <Alert
      customStyle={{ box: "bg-gray-200" }}
      t
      type="info"
      icon="info-circle"
      title="campaign summary"
    >
      <p>
        {`If ${product_name} is on the cart, Then you can add "${product.title
          .substring(0, 25)
          .trim()}
					${must_truncated(product.title) ? "..." : ""}" with one tick.`}
      </p>
    </Alert>
  );
};

function productError (validationErrors, index) {
  const products = validationErrors[`settings.multi_one_check_upsell.products`];
  return products && products[index] ? products[index]["product.id"] : false;
}
